(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentDeliveryActivity', {
        templateUrl: 'views/components/views/consignmentDeliveryActivity/consignmentDeliveryActivity.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$q', '$stateParams', 'stateService', 'fileService', 'docarcService', 'consignmentDeliveryActivityService', function ($q, $stateParams, stateService, fileService, docarcService, consignmentDeliveryActivityService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactNo = $stateParams.custact_no;
            let orderOrderNo = $stateParams.order_order_no;

            vm.model = {
                setting: {},
                itemsListDeliveryActivities: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await consignmentDeliveryActivityService.getSetting({
                    custact_no: custactNo,
                    order_order_no: orderOrderNo
                }))[0];
            }

            async function loadDeliveryActivities() {
                vm.model.itemsListDeliveryActivities = await consignmentDeliveryActivityService.listDeliveryActivities({
                    custact_no: custactNo,
                    order_order_no: orderOrderNo
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region UPLOAD FILE FUNCTION

            vm.uploadFile = function (file) {
                var addToDocarc = function (data) {
                    return docarcService.add({
                        contentType: data.contentType || '',
                        filename: data.fileName,
                        localFileName: data.localFileName || '',
                        originalFileName: data.originalFileName || '',
                        originalDateTime: data.originalDateTime || '',
                        argType: 'custact_no',
                        argValue: custactNo,
                        size: data.size || 0,
                        checksum: data.checksum || '',
                        latitude: data.latitude || 0,
                        longitude: data.longitude || 0,
                        altitude: data.altitude || 0,
                        heading: data.heading || 0,
                        checksum_md5: data.checksum_md5 || 0
                    }, {
                        checksum_md5: data.checksum_md5
                    });
                };

                fileService.uploadFiles({
                    files: [file],
                    preprocess: function (fileName, file) {
                        var ppDeferred1 = $q.defer();

                        fileService.hash(file).then(function (response) {
                            docarcService.exists(fileName, response.hash, '', '').then(function (data) {
                                ppDeferred1.resolve({ cancelUpload: data.exists });
                            });
                        });

                        return ppDeferred1.promise;
                    },
                    postprocess: function (data) {
                        var ppDeferred2 = $q.defer();

                        if (data.fileItemKeyno > 0) {
                            addToDocarc(data).then(function () {
                                ppDeferred2.resolve();
                            });
                        } else {
                            if (data.isError === true) {
                                // ØDL endra frå console til consoleService 28.08.2018
                                consoleService.log(data.message);
                                consoleService.dir(data);
                            }

                            ppDeferred2.resolve();
                        }

                        return ppDeferred2.promise;
                    }
                }).then(function () {
                    console.log('upload complete')
                    stateService.go('consignmentdeliveryactivity', {
                        custact_no: custactNo,
                        order_order_no: orderOrderNo
                    }, { reload: true, inherit: false });
                }).catch(function () {
                    console.log('upload cancelled or')
                    stateService.go('consignmentdeliveryactivity', {
                        custact_no: custactNo,
                        order_order_no: orderOrderNo
                    }, { reload: true, inherit: false });
                });
            };

            // #endregion UPLOAD FILE FUNCTION

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = async function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'consignmentdeliveryconfirm':
                        if (vm.model.setting.checklist_keyno > 0 && vm.model.setting.checklistdata_keyno == 0) {
                            const response = (await consignmentDeliveryActivityService.confirm({
                                argtype: 'custact_no',
                                argvalue: custactNo,
                                checklist_keyno: vm.model.setting.checklist_keyno
                            }))[0];

                            state = 'consignmentdeliveryconfirm';

                            go({
                                checklistdata_keyno: response.parms,
                                custact_no: custactNo,
                                order_order_no: orderOrderNo
                            });
                        } else {
                            go({
                                checklistdata_keyno: vm.model.setting.checklistdata_keyno,
                                custact_no: custactNo,
                                order_order_no: orderOrderNo
                            });
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadSetting();
                loadDeliveryActivities();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
